/**
 * Phaser ゲーム設定
 */
import Phaser from 'phaser';
import { PHASER_CONFIG } from '../../utils/constants';
import { PreloadScene } from '../scenes/PreloadScene';
import { MainGameScene } from '../scenes/MainGameScene';

/**
 * Phaserゲーム設定オブジェクト
 */
export const phaserConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: PHASER_CONFIG.WIDTH,
  height: PHASER_CONFIG.HEIGHT,
  parent: 'phaser-container',
  transparent: true, // Reactの背景を透過
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [PreloadScene, MainGameScene],
  physics: {
    default: 'arcade',
    arcade: {
      debug: false,
    },
  },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
  },
  input: {
    // Ensure input works properly with scaled canvas
    windowEvents: true,
  },
};
